export const formatTime = function (milliseconds: number): string {
  const totalSeconds = Math.floor(milliseconds / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;

  return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(
    2,
    "0"
  )}`;
};

export const throttle = function <T extends (...args: object[]) => void>(fn: T, delay: number) {
  let lastTime = 0;
  return function (...args: Parameters<T>) {
    const now = new Date().getTime();
    if (now - lastTime >= delay) {
      lastTime = now;
      fn(...args);
    }
  };
};

export const randomHash = function (length = 32): string {
  const characters = '0123456789abcdefghijklmnopqrstuvwxyz'

  let result = ''
  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * characters.length)
    result += characters[randomIndex]
  }

  return result
}

/**
 * 判断是否为谷歌爬虫
 * 参考：https://developers.google.com/search/docs/crawling-indexing/google-common-crawlers
 * @param userAgent userAgent字符串
 * @returns 是否为谷歌爬虫
 */
export const isGoogleBot = function (userAgent: string): boolean {
  return /googlebot/i.test(userAgent);
}
